(function (jQuery) {
  jQuery.gfTooltips = function (element, options) {
    const defaults = {
      message: '',
      position: 'bottom',
      background: '',
      delay: 500,
      onSelected: function () {},
    };

    this.settings = {};
    const $element = $('#gfContainer .side-tooltips');

    const _this = this;
    let delay;
    let delay2;
    const bgColor = '#555';

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      return false;
    };

    // Sử dụng cho segment
    this.show = function ($el, text) {
      $element.html('');
      clearTimeout(delay);
      clearTimeout(delay2);
      delay = setTimeout(function () {
        $element.html(text + '<div><span></span></div>');
        let left = $el.offset().left - ($element.width() - $el.width()) / 2;
        let top = $el.offset().top - ($element.height() + 18);
        if (left < 11) {
          left = 19;

          const rect = $el.get(0).getBoundingClientRect();

          $element.find('div span').css({
            transform: 'auto',
            left: $el.offset().left - $el.width() / 2, // FIXME: left position not suitable
          });
        } else {
          $element.find('div span').css({
            transform: 'translateX(-50%)',
            left: '50%',
          });
        }
        if (top + $element.height() + 18 < 50) {
          top = $el.offset().top + $('.side-tooltips').height() + 25;
          $element.find('div span').css({
            'border-top': 'none',
            'border-bottom': '4px solid ' + bgColor,
            bottom: '19px',
          });
        } else {
          $element.find('div span').css({
            'border-top': '4px solid ' + bgColor,
            'border-bottom': 'none',
            bottom: '-10px',
          });
        }
        clearTimeout(delay2);
        delay2 = setTimeout(function () {
          $element.css({
            left: left,
            top: top,
          });
          $element.addClass('side-tooltips-show');
        }, 300);
      }, _this.settings.delay);
      $el.off('mouseout.tt').on('mouseout.tt', function () {
        clearTimeout(delay);
        clearTimeout(delay2);
        _this.hide();
        $el.off('mouseout.tt');
      });
      return false;
    };

    this.hide = function () {
      $element.removeClass('side-tooltips-show');
      return false;
    };

    this.init();
  };
  jQuery.fn.gfTooltips = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gftooltips')) {
        const plugin = new jQuery.gfTooltips(this, options);
        jQuery(this).data('gftooltips', plugin);
      }
    });
  };
})(jQuery);
